import { Card } from 'antd';
import { ChatMessager } from './chat-messager';
import { ChatMessages } from './chat-messages';
import { Helmet } from 'react-helmet';

interface MessagesInput {
  sentBy: string;
  message: string;
  embedding: string;
}
interface ChatMessageSaveInput {
  messages: [MessagesInput];
}

interface RevisionRequestFields {
  [key: string]: boolean;
}

interface Message {
  sentBy: string;
  message: string;
  createdAt: string;
}

interface FinanceDetails {
  transactions?: {
    submission?: {
      amount: number;
    };
    adhocTransactions?: {
      id: string;
      reason: string;
      amount: number;
      createdAt: Date;
      transactionReference: {
        referenceId: string;
      };
    }[];
  };
  financeConfig: {
    glConfig: {
      additionalCharges: {
        type: string;
      }[];
    };
  };
}

export interface CaseData {
  applicant: {
    displayName?: string;
  };
  state: string;
  isCurrentUserAssigned: boolean;
  messages?: Message[];
  financeDetails?: FinanceDetails;
}

interface ChatPageProps {
  canIssueRefund: boolean | undefined;
  caseData: CaseData;
  requestChangesFields: RevisionRequestFields;
  updateMessage: () => void;
  onSave: (data: ChatMessageSaveInput) => void;
  isCaseOrApplicant: string;
}

export const ChatPage: React.FC<ChatPageProps> = (props) => {
  const userInitials = props?.caseData?.applicant?.displayName
    ? props.caseData?.applicant?.displayName
        ?.split(' ')
        .map((name) => name[0])
        .join('')
    : null;

  return (
    <div style={{ display: 'grid', marginTop: 20 }}>
      <Helmet>
        <title>{props?.isCaseOrApplicant} - Messages</title>
      </Helmet>
      <Card hoverable>
        <ChatMessages
          data={props.caseData.messages}
          isAdmin={true}
          transactions={props.caseData?.financeDetails?.transactions}
          userInitials={userInitials as string}
        />
        <ChatMessager
          updateMessage={props.updateMessage}
          onSave={props.onSave}
          requestChangesField={props.requestChangesFields}
          transactions={props.caseData?.financeDetails?.transactions}
          paymentTypes={props.caseData?.financeDetails?.financeConfig?.glConfig?.additionalCharges?.map((charge) => charge.type) ?? []}
          caseState={props.caseData.state}
          isAssigned={props.caseData.isCurrentUserAssigned}
          canIssueRefund={props.canIssueRefund ?? false}
        />
      </Card>
    </div>
  );
};

export default ChatPage;
